var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.742 7H5.259a2.617 2.617 0 0 0-2.613 2.613v12.773A2.616 2.616 0 0 0 5.26 25h21.483a2.616 2.616 0 0 0 2.612-2.613V9.613A2.616 2.616 0 0 0 26.742 7zm-.07 1.742L16.615 18.797a.87.87 0 0 1-1.231 0L5.33 8.742H26.67zM4.387 22.316V10.264l6.026 6.026-6.026 6.026zm1.522.941 5.736-5.736 2.507 2.507a2.616 2.616 0 0 0 3.695 0l2.507-2.507 5.736 5.736H5.91zm21.703-.941-6.026-6.026 6.026-6.026v12.052z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.74d0f16465f05caf0484db22fcd402be.svg";
export { ForwardRef as ReactComponent };